import { createSelector } from "reselect";

function uniqueId(object) {
  if (!object || !object.id) {
    return null;
  }

  return `${object.type}${object.id}`;
}

const rebuildFromState = (modelToRebuild, state, cache = {}) => {
  if (!modelToRebuild) {
    return null;
  }

  let uuid = uniqueId(modelToRebuild);
  let cachedObject = cache[uuid];
  if (cachedObject) {
    return cachedObject;
  }

  let model = Object.assign({}, modelToRebuild);

  if (!model.relationships) {
    return model;
  }
  cache[uuid] = model;

  Object.keys(model.relationships).forEach(relationshipKey => {
    if (Array.isArray(model.relationships[relationshipKey].data)) {
      model[relationshipKey] = model.relationships[relationshipKey].data
        .filter(
          relationshipData =>
            state.data[relationshipData.type] &&
            state.data[relationshipData.type][relationshipData.id]
        )
        .map(relationshipData => {
          return rebuildFromState(
            state.data[relationshipData.type][relationshipData.id],
            state,
            cache
          );
        });
    } else {
      if (model.relationships[relationshipKey].data) {
        let dataType = model.relationships[relationshipKey].data.type;
        if (
          state.data[dataType] &&
          state.data[dataType][model.relationships[relationshipKey].data.id]
        ) {
          //   model[relationshipKey] = Object.assign(
          //     {},
          //     state.data[dataType][model.relationships[relationshipKey].data.id]
          //   );
          model[relationshipKey] = rebuildFromState(
            state.data[dataType][model.relationships[relationshipKey].data.id],
            state,
            cache
          );
        } else {
          model[relationshipKey] = null;
        }
      }
    }
  });

  return model;
};

const getPatients = (state, props) =>
  state.data.patients
    ? Object.keys(state.data.patients).map(patientId => {
        let patient = state.data.patients[patientId];

        // Object.keys(patient.relationships).forEach(relationshipKey => {
        // });
        let updatedPatient = rebuildFromState(patient, state);
        // updatedPatient.patientCondition.forEach(
        //   (patientCondition, index) =>
        //     (updatedPatient.patientCondition[index] = rebuildFromState(
        //       patientCondition,
        //       state
        //     ))
        // );
        return updatedPatient;
      })
    : [];

export const makeGetPatients = () => {
  return createSelector([getPatients], patients => {
    return patients;
  });
};

const getPatient = (state, props) => {
  let patient = state.data.patients[props.match.params.id];

  let updatedPatient = rebuildFromState(patient, state);

  return updatedPatient;
};

export const makeGetPatient = () => {
  return createSelector([getPatient], patient => {
    return patient;
  });
};

const getPrograms = (state, props) =>
  state.data.programs
    ? Object.keys(state.data.programs).map(programId => {
        let program = state.data.programs[programId];

        let updatedProgram = rebuildFromState(program, state);

        return updatedProgram;
      })
    : [];

export const makeGetPrograms = () => {
  return createSelector([getPrograms], programs => {
    return programs;
  });
};

const getHistory = (state, props) =>
  state.data.versions
    ? Object.keys(state.data.versions).map(historyId => {
        let history = state.data.versions[historyId];

        let updatedHistory = rebuildFromState(history, state);

        return updatedHistory;
      })
    : [];

export const makeGetHistory = () => {
  return createSelector([getHistory], history => {
    return history;
  });
};
const getProgram = (state, props) => {
  let program = state.data.programs[props.match.params.id];

  let updatedProgram = rebuildFromState(program, state);

  return updatedProgram;
};

export const makeGetProgram = () => {
  return createSelector([getProgram], program => {
    return program;
  });
};

const getAccounts = (state, props) =>
  state.data.accounts
    ? Object.keys(state.data.accounts).map(accountId => {
        let account = state.data.accounts[accountId];

        let updated = rebuildFromState(account, state);

        return updated;
      })
    : [];

export const makeGetAccounts = () => {
  return createSelector([getAccounts], accounts => {
    return accounts;
  });
};

const getAccount = (state, props) => {
  let account = undefined;
  if (state.data.accounts) {
    account =
      props.match && props.match.params.id
        ? state.data.accounts[props.match.params.id]
        : state.data.accounts[Object.keys(state.data.accounts)[0]];
  }

  let updated = rebuildFromState(account, state);

  return updated;
};

export const makeGetAccount = () => {
  return createSelector([getAccount], account => {
    return account;
  });
};

const getDashboard = (state, props) => {
  let dashboard = undefined;
  if (state.data.dashboard) {
    dashboard = state.data.dashboard[Object.keys(state.data.dashboard)[0]];
  }

  let updated = rebuildFromState(dashboard, state);

  return updated;
};

export const makeGetDashboard = () => {
  return createSelector([getDashboard], dashboard => {
    return dashboard;
  });
};

const getActivity = (state, props) => {
  return state.data.patientProgramActivities
    ? Object.keys(state.data.patientProgramActivities).map(id => {
        let activity = state.data.patientProgramActivities[id];

        let updatedActivity = rebuildFromState(activity, state);

        return updatedActivity;
      })
    : [];
};

export const makeGetActivity = () => {
  return createSelector([getActivity], patientProgramActivities => {
    return patientProgramActivities;
  });
};

const getTasks = (state, props) =>
  state.data.tasks
    ? Object.keys(state.data.tasks).map(taskId => {
        let task = state.data.tasks[taskId];

        let updatedTask = rebuildFromState(task, state);

        return updatedTask;
      })
    : [];
export const makeGetTasks = () => {
  return createSelector([getTasks], tasks => {
    return tasks;
  });
};

const getConditions = (state, props) =>
  state.data.conditions
    ? Object.keys(state.data.conditions).map(conditionId => {
        let condition = state.data.conditions[conditionId];

        let updatedTask = rebuildFromState(condition, state);

        return updatedTask;
      })
    : [];
export const makeGetConditions = () => {
  return createSelector([getConditions], conditions => {
    return conditions;
  });
};

const getAttachments = (state, props) =>
  state.data.attachments
    ? Object.keys(state.data.attachments).map(attachmentId => {
        let attachment = state.data.attachments[attachmentId];

        let updatedAttachment = rebuildFromState(attachment, state);

        return updatedAttachment;
      })
    : [];

export const makeGetAttachments = () => {
  return createSelector([getAttachments], attachments => {
    return attachments;
  });
};

const getUsers = (state, props) =>
  state.data.users
    ? Object.keys(state.data.users).map(userId => {
        let user = state.data.users[userId];

        let updatedUser = rebuildFromState(user, state);

        return updatedUser;
      })
    : [];

export const makeGetUsers = () => {
  return createSelector([getUsers], users => {
    return users;
  });
};

const getClinicians = (state, props) =>
  state.data.clinicians
    ? Object.keys(state.data.clinicians).map(id => {
        let user = state.data.clinicians[id];

        let updatedUser = rebuildFromState(user, state);

        return updatedUser;
      })
    : [];
export const makeGetClinicians = () => {
  return createSelector([getClinicians], users => {
    return users.filter(
      u => u.user && u.user.attributes.userRoles === "clinician"
    );
  });
};

const getUser = (state, props) => {
  let user = state.data.users[props.match.params.id];

  let updatedUser = rebuildFromState(user, state);

  return updatedUser;
};

export const makeGetUser = () => {
  return createSelector([getUser], user => {
    return user;
  });
};

const getLocations = (state, props) =>
  state.data.locations
    ? Object.keys(state.data.locations).map(locationId => {
        let location = state.data.locations[locationId];

        let updatedLocation = rebuildFromState(location, state);

        return updatedLocation;
      })
    : [];

export const makeGetLocations = () => {
  return createSelector([getLocations], locations => {
    return locations;
  });
};

const getLocation = (state, props) => {
  let location = state.data.locations[props.match.params.id];

  let updatedLocation = rebuildFromState(location, state);

  return updatedLocation;
};

export const makeGetLocation = () => {
  return createSelector([getLocation], location => {
    return location;
  });
};

const getUserLookup = (state, props) =>
  state.data.userLookup && state.data.userLookup.users
    ? Object.keys(state.data.userLookup.users).map(userId => {
        let user = state.data.userLookup.users[userId];

        let updatedUser = rebuildFromState(user, state);

        return updatedUser;
      })
    : [];

export const makeGetUserLookup = () => {
  return createSelector([getUserLookup], users => {
    return users;
  });
};



// WEBPACK FOOTER //
// ./src/selectors/data.js